import { html } from "lit";
var icon_view_default = () => html`
  <svg stroke-fill viewBox="0 0 30 19" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path
        d="M14.998 1.002C9.982.917 4.794 4.422 1.532 8.012a2.07 2.07 0 0 0 0 2.771c3.19 3.514 8.364 7.1 13.466 7.015 5.102.086 10.277-3.5 13.47-7.015a2.07 2.07 0 0 0 0-2.77c-3.265-3.59-8.453-7.096-13.47-7.011Z" />
      <path d="M19.665 9.4a4.667 4.667 0 1 1-9.334-.002 4.667 4.667 0 0 1 9.334.002h0Z" />
    </g>
  </svg>
`;
export {
  icon_view_default as default
};
//# sourceMappingURL=icon-view.js.map
